import { Crown, UserRound, Plane, Ship, Sparkles, Percent, Dumbbell, HeartPulse, Ticket } from "lucide-react";

// Per-perk icons. Keys are feature translation keys; anything unmapped falls back to a check.
export const FEATURE_ICONS = {
  "vc.mem.f.vip-1": Crown,
  "vc.mem.f.vip-2": UserRound,
  "vc.mem.f.vip-3": Plane,
  "vc.mem.f.vip-4": Ship,
  "vc.mem.f.vip-5": Sparkles,
  "vc.mem.f.vip-6": Percent,
  "vc.mem.f.vip-7": Dumbbell,
  "vc.mem.f.vip-8": HeartPulse,
  "vc.mem.f.vip-9": Ticket,
};

export const TIERS = [
  {
    id: "silver",
    name: "Silver",
    price: "vc.mem.free",
    period: "",
    tag: "vc.mem.silver-tag",
    body: "vc.tiers.silver-desc",
    features: ["vc.mem.f.silver-1", "vc.mem.f.silver-2", "vc.mem.f.silver-3", "vc.mem.f.silver-4", "vc.mem.f.silver-5"],
  },
  {
    id: "gold",
    name: "Gold",
    price: "$3,000",
    period: "vc.mem.per-year",
    tag: "vc.mem.gold-tag",
    body: "vc.tiers.gold-desc",
    popular: true,
    features: ["vc.mem.f.gold-1", "vc.mem.f.gold-2", "vc.mem.f.gold-3", "vc.mem.f.gold-4", "vc.mem.f.gold-5", "vc.mem.f.gold-6"],
  },
  {
    id: "vip",
    name: "VIP",
    price: "$7,000",
    period: "vc.mem.per-year",
    tag: "vc.mem.vip-tag",
    body: "vc.tiers.vip-desc",
    features: ["vc.mem.f.vip-1", "vc.mem.f.vip-2", "vc.mem.f.vip-3", "vc.mem.f.vip-4", "vc.mem.f.vip-5", "vc.mem.f.vip-6", "vc.mem.f.vip-7", "vc.mem.f.vip-8", "vc.mem.f.vip-9"],
  },
  {
    id: "corporate",
    name: "Corporate",
    price: "vc.mem.custom",
    period: "",
    tag: "vc.mem.corp-tag",
    body: "vc.tiers.corp-desc",
    features: ["vc.mem.f.corp-1", "vc.mem.f.corp-2", "vc.mem.f.corp-3", "vc.mem.f.corp-4", "vc.mem.f.corp-5", "vc.mem.f.corp-6"],
  },
];

export const priceOf = (tier, t) => (tier.price.startsWith("vc.") ? t(tier.price) : tier.price);
